

// FOR REDUCER
export interface AuthenticationState {
    isLoggedIn: boolean;
    user: User | null;
    error: string | null;
    isAvatarProcessing: boolean;
    isProfileUpdated: boolean;
    loading: boolean;
}

export const sharedInitialState: AuthenticationState = {
    isLoggedIn: false,
    user: null,
    error: null,
    isAvatarProcessing: false,
    isProfileUpdated: false,
    loading: false
}


//OTHERS
export class User {
  id?: number;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  token?: string;
  lang?: string;
  avatar?: string;

  qrcode?: string | null;
  two_factor_backup_codes?: [];
}

export interface TwoFactorQr {
  qrcode?: string;
}

export interface TwoFactorCode {
  code?: string;
}

export interface PasswordSetup {
  password?: string;
}

export interface ForgotEmail {
  email?: string;
}

export interface LoginData {
  email?: string;
  password?: string;
}

export interface resetPasswordData {
  token?: string;
  email?: string;
  password?: string;
}
